import { Tabs } from 'antd'
import { JourneyPreviewFragment } from '~/gql/generated/graphql'
import { IDProps } from '.'
import JourneyHistory from '../History'
import JourneySummary from '../Summary'

interface Props {
  journeys: JourneyPreviewFragment[]
  activeJourneyId?: string
  setActiveJourneyId: React.Dispatch<React.SetStateAction<string>>
}

const JourneyTabJourney = ({ id }: IDProps) => (
  <>
    <JourneySummary id={id} withLink />
    <JourneyHistory id={id} />
  </>
)

const JourneyTabs = ({
  journeys,
  activeJourneyId,
  setActiveJourneyId,
}: Props) => {
  const items = journeys.map(({ id }) => ({
    key: id,
    label: `Journey ${id}`,
    children: <JourneyTabJourney id={id} />,
  }))

  return (
    <Tabs
      items={items}
      activeKey={activeJourneyId ?? journeys[0].id}
      onTabClick={setActiveJourneyId}
    />
  )
}

export default JourneyTabs
